import React from 'react';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTranslation } from 'react-i18next';



import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  uploadingIcon: {
    '& svg': {
      color: theme.color.icon.iconDefault,
    },
  },
}));

const UploadingInProgress = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <IconWithLabel
      className={classes.uploadingIcon}
      iconName={IconName.loadingIndicator}
      iconSize="M"
      label={t('components->>UploadingInProgress.UploadingInProgressDescription')}
      typographyProps={{
        variant: 'h5',
        color: 'inherit',
      }}
    />
  );
};

export default UploadingInProgress;
